import { useAuthStatus } from "../hooks/useAuthStatus";
import { hasFeatureAccess } from "../utils/access";

// Renders its children only when the current user's plan unlocks `feature`.
// Otherwise it shows a "locked" message. Subscription tiers are resolved in
// utils/access.js, so this component does not need to change as plans evolve.
function FeatureGate({ feature, featureName, children }) {
  const { currentUser, userSettings } = useAuthStatus();
  const allowed = hasFeatureAccess(feature, currentUser, userSettings);

  if (allowed) {
    return children;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-3 p-6 text-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-10 h-10 text-base-content/40"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
        />
      </svg>
      <div>
        <p className="font-semibold">
          {featureName || "This feature"} is not available on your plan
        </p>
        <p className="text-xs text-base-content/60 mt-1">
          Upgrade your subscription to unlock {featureName || "this feature"}.
        </p>
      </div>
    </div>
  );
}

export default FeatureGate;
